import { useMutation, UseMutationResult } from 'react-query';

interface UseMutationAuthMagicLinkData {
  retryWaitTimeInSeconds: number;
}

interface UseMutationAuthMagicLinkError {
  errors: any;
  message?: string;
  status?: number;
}

interface UseMutationAuthMagicLinkVariables {
  email: string;
  redirectTo: string;
}

const useMutationAuthMagicLink = () => {
  const mutation: UseMutationResult<
    UseMutationAuthMagicLinkData,
    UseMutationAuthMagicLinkError,
    UseMutationAuthMagicLinkVariables
  > = useMutation(async variables => {
    const fetchResponse = await fetch('/api/services/auth/magic-link', {
      body: JSON.stringify({
        ...variables,
      }),
      headers: {
        ['Content-Type']: 'application/json',
      },
      method: 'POST',
    })
      .then(async response => {
        const responseData = await response.json().catch(() => null);

        if (!response.ok) {
          return Promise.reject({
            errors: responseData,
            message: response.statusText,
            status: response.status,
          });
        }

        return responseData;
      })
      .catch(error => {
        console.error('services.useAuthMagicLink', error);

        return Promise.reject({
          errors: error,
          message: error.message ?? 'Network error',
          status: error.status ?? 0,
        });
      });

    return fetchResponse;
  });

  return mutation;
};

export default useMutationAuthMagicLink;
